import check from 'check-types'

const getOptionsData = (matchData) => matchData.get('options');
const getSelectionsData = (matchData) => matchData.get('selections');
const isAnswered = (localAnswer) => check.nonEmptyObject(localAnswer);

export {getOptionsData, getSelectionsData, isAnswered}